import { getIn, useFormikContext } from 'formik';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';
import React from 'react'
import { useState } from 'react';

export default function PhoneTextField({ name, name2, name3, ...otherProps }) {
  const [blur, setBlur] = useState(true);

  const { values, touched, errors, setFieldValue,setValues, handleBlur, dirty, setFieldTouched } = useFormikContext();

  return (
    <MuiTelInput
      forceCallingCode={true}
      focusOnSelectCountry={true}
      disableFormatting={true}
      onChange={(value, info) => {
        const payload = {};
        // payload[name] = value;
        // payload[name2] = info.nationalNumber;
        // payload[name3] = '+' + info.countryCallingCode
        setFieldValue(name, value);
        setFieldValue(name2, info.nationalNumber, false);
        setFieldValue(name3, '+' + info.countryCallingCode, false);
        // setValues(payload, true)
        setBlur(false);
      }}
      onBlur={(e) => {
        handleBlur(e);
        setFieldTouched(name, true, true);
        var regex = /^\s*$/;
        if (!regex.test(getIn(values, name))) {
          setBlur(true);
        } else {
          setBlur(false);
        }
      }}
      value={getIn(values, name)}
      error={blur && Boolean(getIn(values, name)) && touched.name && Boolean(getIn(errors, name))}
      helperText={blur && Boolean(getIn(values, name)) && (touched[name] || dirty[name]) && getIn(errors, name)}
      {...otherProps}
    />
  )
}
